require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/fn/object/keys.js